import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
export const NavigateToContext = createContext({
    navigateTo: () => {
        throw new Error('navigateTo must be used within a NavigateToProvider');
    },
});
export const useNavigateToContext = () => useContext(NavigateToContext);
export const NavigateToProvider = ({ children, navigateTo, }) => {
    const contextValue = useMemo(() => ({ navigateTo }), [navigateTo]);
    return (_jsx(NavigateToContext.Provider, { value: contextValue, children: children }));
};
//# sourceMappingURL=NavigateToProvider.js.map